import script from "./Util.vue?vue&type=script&lang=js"
export * from "./Util.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__